export default __webpack_public_path__ + "static/media/kabira.9ceebdd1.jpg";